var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.2C4 5.53726 4.53726 5 5.2 5H19.6C20.2627 5 20.8 5.53726 20.8 6.2C20.8 6.86274 20.2627 7.4 19.6 7.4H5.2C4.53726 7.4 4 6.86274 4 6.2Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.2C4 11.5373 4.53726 11 5.2 11H19.6C20.2627 11 20.8 11.5373 20.8 12.2C20.8 12.8627 20.2627 13.4 19.6 13.4H5.2C4.53726 13.4 4 12.8627 4 12.2Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 18.2C4 17.5373 4.53726 17 5.2 17H19.6C20.2627 17 20.8 17.5373 20.8 18.2C20.8 18.8627 20.2627 19.4 19.6 19.4H5.2C4.53726 19.4 4 18.8627 4 18.2Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsMenu);
export default __webpack_public_path__ + "static/media/actions-menu.bd9c08d12fa64d614b147283c859ab3f.svg";
export { ForwardRef as ReactComponent };